import React from 'react'
import MetarDetailSection from './MetarDetailSection'
import MetarDetailSectionItem from './MetarDetailSectionItem'
import './styles/MetarDetailWeather.css'
import { WEATHER_PHENOMENA } from '../util/constants'

const MetarDetailWeather = props => {

  const decodeWeather = weatherCode => {
    var decodeTextArray = []
    WEATHER_PHENOMENA.map(wprec => {
      if(weatherCode.indexOf(wprec.code) >= 0) {
          decodeTextArray.push(wprec.name)
          weatherCode = weatherCode.replace(wprec.code, "")
      }
      return wprec //dummy return
    })
    if(decodeTextArray.length > 0) {
      return decodeTextArray.join(" ")
    }
    return weatherCode
  }

  if(!props.weather) {
    return null
  }
  return (
    <MetarDetailSection
      className="metarDetailWeather"
      title={"PRESENT WEATHER"}
    >
      {props.weather.map(rec => {
        return (
          <MetarDetailSectionItem
            key={rec}
            value={decodeWeather(rec)}
            footer={rec}
          />
        )
      })}
    </MetarDetailSection>
  )
}

export default MetarDetailWeather



// WEBPACK FOOTER //
// ./src/components/MetarDetailWeather.js